module.exports = __webpack_public_path__ + "media/images/sp/stores/sola/instagram/sola_sns_04-3c2adb4268bdf3415dbe3de5b9bfc9a5.jpg";